import styled from "styled-components";
import { Link } from "react-router-dom";
import { Link as LinkS } from "react-scroll";

export const ButtonS = styled(LinkS)`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  white-space: nowrap;
  outline: none;
  border: none;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s ease-in-out;
  background-color: ${({ primary }) => (primary ? "#c9a43d" : "#010606")};
  color: ${({ dark }) => (dark ? "#010606" : "#fff")};
  padding: ${({ big }) => (big ? "14px 48px" : "12px 30px")};
  font-size: ${({ fontBig }) => (fontBig ? "20px" : "16px")};

  &:hover {
    transition: all 0.2s ease-in-out;
    background-color: ${({ primary }) => (primary ? "#fff" : "#c9a43d")};
  }
`;

export const ButtonL = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  white-space: nowrap;
  outline: none;
  border: none;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s ease-in-out;
  background-color: ${({ primary }) => (primary ? "#c9a43d" : "#010606")};
  color: ${({ dark }) => (dark ? "#010606" : "#fff")};
  padding: ${({ big }) => (big ? "14px 48px" : "12px 30px")};
  font-size: ${({ fontBig }) => (fontBig ? "20px" : "16px")};

  &:hover {
    transition: all 0.2s ease-in-out;
    background-color: ${({ primary }) => (primary ? "#fff" : "#c9a43d")};
  }
`;

export const ButtonExternalLink = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  white-space: nowrap;
  outline: none;
  border: none;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s ease-in-out;
  background-color: ${({ primary }) => (primary ? "#c9a43d" : "#010606")};
  color: ${({ dark }) => (dark ? "#010606" : "#fff")};
  padding: ${({ big }) => (big ? "14px 48px" : "12px 30px")};
  font-size: ${({ fontBig }) => (fontBig ? "20px" : "16px")};

  &:hover {
    transition: all 0.2s ease-in-out;
    background-color: ${({ primary }) => (primary ? "#fff" : "#c9a43d")};
  }
`;